import React from 'react';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import { useRightColumnContext } from 'Context/RightColumnContext';

export const AskMyPlannerButton = ({ relationship: rel }) => {
  const { loadRightColumnCollectionLink, rightColumnCollectionLoading } = useRightColumnContext();

  return (<FDSecondaryActionButton
    label={rel.meta('prompt')}
    icon={'chatBubbleOutline'}
    loading={rightColumnCollectionLoading ?? false}
    onClick={() => {
      loadRightColumnCollectionLink(rel.link('related'));
    }}
    {...dataAttrs('ask-my-planner-button')}
    isFullWidth
  />);
};

AskMyPlannerButton.propTypes = {
  relationship: PropTypes.object.isRequired,
};
